export const hasLocationFilter = selectedLocalities => {
  return selectedLocalities && selectedLocalities.length >= 1
}
